import React from 'react';
import './Loader.css';

interface LoaderProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({
  message = 'Loading...',
  size = 'medium',
  fullScreen = false,
  className = '',
}) => {
  const loaderContent = (
    <div className={`loader-container ${fullScreen ? 'fullscreen' : ''} ${className}`}>
      <div className={`loader-spinner loader-${size}`}>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      {message && <p className="loader-message">{message}</p>}
    </div>
  );

  return loaderContent;
};

export default Loader;

